import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { UpdateUserRequest, User } from '../interfaces/user';

@Injectable({
  providedIn: 'root'
})
export class UsersApiService {

  private http = inject(HttpClient);
  private url = environment.apiUrl + 'user/';

  constructor() { }

  getUsers(accountId: string | undefined = undefined): Observable<any[]> {
      let params = new HttpParams();
      if (accountId) {
        params = params.set('accountId', accountId);
      }
      return this.http.get<User[]>(this.url, {params: params});
  }

  createUser(user: User): Observable<any[]> {
      return this.http.post<any>(this.url, user);
  }

  updateUser(user: UpdateUserRequest): Observable<User> {
      return this.http.put<User>(this.url + user.id, user);
  }

  /** Emails the user a sign-up link (unfinished) or reset link; scoped on the server (spec 004, FR-012). */
  sendPasswordLink(userId: string): Observable<void> {
      return this.http.post<void>(this.url + userId + '/password-link', {});
  }
}
